import { cn } from '@nextui-org/react'
import type { KeyboardEvent } from 'react'
import { forwardRef, useCallback, useState } from 'react'
import { useSimpleTextareaClassName } from '~/hooks'
import { AppEvents, globalEventEmitter } from '~/utils/shared'
import { cm } from '~/utils/utils'
import { CurieTextarea } from './chat/ChatInput'

interface SimpleTextareaProps {
  className?: string
  onChange?: (value: string) => void
  enter2Submit?: boolean
  minRows?: number
  maxRows?: number
  placeholder?: string
  autoFocus?: boolean
  value?: string
  defaultValue?: string
  inputClassName?: string
  onBlur?: () => void
}

export const SimpleTextarea = forwardRef<HTMLTextAreaElement, SimpleTextareaProps>(
  (
    {
      className,
      onChange,
      enter2Submit = false,
      minRows = 13,
      maxRows = 13,
      placeholder = 'Type a message...',
      autoFocus = false,
      value,
      defaultValue,
      inputClassName: userInputClassName,
      onBlur
    },
    forwardedRef
  ) => {
    const { className: inputClassName, ref: innerRef } = useSimpleTextareaClassName({
      rows: minRows
    })
    const [isComposing, setIsComposing] = useState(false)

    const onKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
      if (event.key === 'Enter' && !event.shiftKey && !isComposing && enter2Submit) {
        event.preventDefault() // prevent a new line
        globalEventEmitter.emit(AppEvents.SubmitTask)
      }
    }

    const refCallback = useCallback(
      (textareaElement: HTMLTextAreaElement | null) => {
        innerRef.current = textareaElement
        if (typeof forwardedRef === 'function') {
          forwardedRef(textareaElement)
        } else if (forwardedRef) {
          forwardedRef.current = textareaElement
        }
      },
      [forwardedRef]
    )

    return (
      <CurieTextarea
        defaultValue={defaultValue}
        value={value}
        autoFocus={autoFocus}
        className={cn('curie-textarea', className)}
        onChange={e => onChange?.(e.currentTarget.value)}
        onKeyDown={onKeyPress}
        onCompositionStart={() => setIsComposing(true)}
        onCompositionEnd={() => setIsComposing(false)}
        placeholder={placeholder}
        maxRows={maxRows}
        minRows={minRows}
        ref={refCallback}
        onBlur={() => onBlur?.()}
        classNames={{
          inputWrapper: 'shadow-sm ring-1 ring-[#d4dce2]',
          input: cm('curie-input pr-4', inputClassName, userInputClassName)
          
        }}
      />
    )
  }
)
